'use client';

import { DisplayOnMountedAdSlot } from '@fe-news/components/atoms/AdSlot';
import { HeadlineAdProfiles } from '@fe-news/constants/DFP';
import { styled } from '@linaria/react';
import { useEffect, useRef } from 'react';

const DESKTOP_ADS = [
  HeadlineAdProfiles.loadOnMounted.desktop.newslistNativeList1,
  HeadlineAdProfiles.loadOnMounted.desktop.newslistNativeList2,
  HeadlineAdProfiles.loadOnMounted.desktop.newslistNativeList3,
  HeadlineAdProfiles.loadOnMounted.desktop.newslistNativeList4,
  HeadlineAdProfiles.loadOnMounted.desktop.newslistNativeList5,
  HeadlineAdProfiles.loadOnMounted.desktop.newslistNativeList6
];

const View = styled.div`
  height: 113px;
  border-bottom: 1px solid #e2e8f1;
  margin-top: 15px;
`;

type DesktopAdCardProps = {
  index: number;
  style: React.CSSProperties;
  onChangeCurrentVisibleAd: (v: number) => void;
  visibleAds: number[];
};
export const DesktopAdCard = ({ index, style, visibleAds, onChangeCurrentVisibleAd }: DesktopAdCardProps) => {
  const pos = index % DESKTOP_ADS.length;
  const profile = DESKTOP_ADS[pos];
  const reference = useRef<HTMLDivElement | null>(null);
  const isAdVisible = visibleAds?.includes(index);

  useEffect(() => {
    const referenceCurrent = reference.current;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        const isVisible = entry.isIntersecting;
        if (isVisible) {
          onChangeCurrentVisibleAd(index);
        }
      },
      {
        root: null,
        rootMargin: '115px',
        threshold: 0
      }
    );

    if (referenceCurrent) {
      observer.observe(referenceCurrent);
    }

    // Clean up the observer
    return () => {
      if (referenceCurrent) {
        observer.unobserve(referenceCurrent);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const visibleStyle = isAdVisible ? {} : { height: 0, margin: 0, borderWidth: 0 };

  return (
    <View id={`desktop-ad-card-${index}`} ref={reference} style={{ ...style, ...visibleStyle }}>
      {/* <span style={{color: 'red'}}>{index}</span> */}
      {isAdVisible && <DisplayOnMountedAdSlot profile={profile} />}
    </View>
  );
};
